

import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';


import React, { Fragment, useContext } from 'react';
import HomePsico from '../views/psicologo/home_psico';
import CitaSinglePsico from '../views/psicologo/cita_single_psico';
import { AuthContext } from '../context/auth_context';
import TipsPsico from '../views/psicologo/tips_psico';
import DocumentosPsico from '../views/psicologo/documents_psico';



function PsicoNavigator() {
  return (
  
    <PrivateRoutes>
        <Routes>
            <Route exact path="/" element={<HomePsico></HomePsico>} />
            <Route exact path="/cita/:cita_id" element={<CitaSinglePsico></CitaSinglePsico>} />
            <Route exact path="/tips" element={<TipsPsico></TipsPsico>} />
            <Route exact path="/documentos" element={<DocumentosPsico></DocumentosPsico>} />
        </Routes>  
    </PrivateRoutes> 
  );
}



function PrivateRoutes({ children }) {
    const { user } = useContext(AuthContext);
    // console.log(user);

    // return user.roles?.includes("Psychologist") && !user.roles?.includes("Admin") ? children : <Navigate to="/" />;
    return user.roles?.includes("Coach") ? children : <Navigate to="/" />;
}



export default PsicoNavigator;
